import R from 'ramda'

const OVERLAY_GIF_ACTION_TYPE = 'OVERLAY_GIF'
const OVERLAY_GIF_DISPLAY_TYPE = 'Send overlay'

const isOverlayGifWidgetAction = R.propEq('type', OVERLAY_GIF_ACTION_TYPE)

const getOverlayMediaId = R.pipe(
  R.ifElse(
    R.has('overlayMediaId'),
    R.pipe(R.prop('overlayMediaId'), R.of),
    R.always(undefined)
  )
)

const convertOverlayGifWidgetActionToFormAction = R.applySpec({
  type: R.always(OVERLAY_GIF_DISPLAY_TYPE),
  overlayType: R.prop('type'),
  message: R.prop('message'),
  isPromotedTweet: R.prop('isPromotedTweet'),
  overlayMediaId: getOverlayMediaId
})

export { isOverlayGifWidgetAction, convertOverlayGifWidgetActionToFormAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/overlay-gif.js